import { sportsCategories } from "../../../mocks/sportsSchedule";

interface CategoryFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({ activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
        {sportsCategories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              activeCategory === category.id
                ? "bg-brand-orange text-white"
                : "bg-dark-surface text-dark-text-muted border border-dark-border hover:border-brand-orange hover:text-white"
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${category.icon} text-sm`}></i>
            </span>
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}